// src/components/TemplatePlantillaPro/WhatsAppPanel.jsx
import React, { useEffect, useMemo, useState } from "react";

function parseWaTemplateToHtml(text = "") {
  const esc = (s = "") =>
    String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  const placeholders = [];
  const hold = (html) => {
    const key = `__CODE_BLOCK_${placeholders.length}__`;
    placeholders.push({ key, html });
    return key;
  };
  let txt = esc(text ?? "");
  txt = txt.replace(/```([\s\S]*?)```/g, (_, c) => hold(`<pre class="wa-mono">${c}</pre>`));
  txt = txt.replace(/\*(.+?)\*/g, "<strong>$1</strong>");
  txt = txt.replace(/_(.+?)_/g, "<em>$1</em>");
  txt = txt.replace(/~(.+?)~/g, "<span class='wa-strike'>$1</span>");
  txt = txt.replace(/\{([a-zA-Z0-9_\-]+)\}/g, "<span class='wa-var'>{$1}</span>");
  txt = txt.replace(/\n/g, "<br/>");
  for (const ph of placeholders) txt = txt.replace(ph.key, ph.html);
  return txt;
}

export default function WhatsAppPanel({
  template,
  setTemplate,
  columns,
  zoom,
  setZoom,
}) {
  const [waPreview, setWaPreview] = useState("");

  useEffect(() => {
    setWaPreview(parseWaTemplateToHtml(template));
  }, [template]);

  const varChips = useMemo(
    () => (columns || []).filter(Boolean).slice(0, 24),
    [columns]
  );

  return (
    <>
      {/* chips + zoom */}
      <div className="flex items-center justify-between gap-3 mb-2"
           style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:12,flexWrap:"wrap",padding:"0 16px"}}>
        <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
          {(varChips.length>0 ? varChips : ["nombre","fecha"]).map((c,i)=>(
            <span key={i} className="px-2.5 py-1 rounded-full text-xs border border-slate-600 bg-slate-800 text-slate-100" title={`{${c}}`}>
              {`{${c}}`}
            </span>
          ))}
        </div>
        <div style={{display:"flex",alignItems:"center",gap:8,fontSize:12}}>
          <span>Zoom</span>
          <input
            type="range"
            min={0.8}
            max={1.2}
            step={0.05}
            value={zoom}
            onChange={(e)=>setZoom(parseFloat(e.target.value))}
          />
          <span style={{width:36,textAlign:"right"}}>{Math.round(zoom*100)}%</span>
        </div>
      </div>

      {/* Editor */}
      <div className="field">
        <label className="label">Mensaje de WhatsApp</label>
        <textarea
          className="textarea"
          value={template}
          onChange={(e)=>setTemplate(e.target.value)}
          placeholder="Ej: Hola *{nombre}*, te recordamos tu cita el _{fecha}_..."
        />
        <div className="hint">*negrita*, _itálicas_, ~tachado~, ```mono```, y variables {"{var}"}.</div>
      </div>

      {/* Preview */}
      <div style={{display:"grid",gap:12, marginTop:12}}>
        <div className="space-y-2">
          <label className="text-xs text-slate-400">Vista previa (WhatsApp)</label>
          <div style={{ transform:`scale(${zoom})`, transformOrigin:"top left" }}>
            <div className="phone">
              <div className="phone-screen">
                <div className="phone-header">
                  <div className="phone-avatar" />
                  <div>Contacto</div>
                </div>
                <div className="phone-chat">
                  <div className="bubble-row">
                    <div className="bubble">
                      <span dangerouslySetInnerHTML={{ __html: waPreview }} />
                      <div className="bubble-meta">12:45 ✓✓</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="hint">Orientativo; el parser real de WhatsApp puede variar.</div>
        </div>
      </div>
    </>
  );
}
